module.exports = __webpack_public_path__ + "img/1_1-macerie-2.b3ec5a11.png";